import { t } from "@/i18n-js/instance";

interface GrandfatheredAddonsWarningProps {
  addonNames: string;
}

export const GrandfatheredAddonsWarning = ({
  addonNames,
}: GrandfatheredAddonsWarningProps) => (
  <div className="mt-6 rounded-md border border-l-8 border-amber-500 p-5">
    <p
      dangerouslySetInnerHTML={{
        __html: t("settings.billing.add_ons.manage.grandfathered_addons", {
          addons: addonNames,
        }),
      }}
    />
  </div>
);
